export default __webpack_public_path__ + "static/media/flag-kiribati.33d5ed98.svg";